/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import CreateNewProfessionalModal from 'DesignSystem/CreateNewProfessionalModal/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/LetterRecipientPicker/Content/Recipient/AddProfessional/Content",
  patientId
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let onSave = fromHelpers.useOnSave({
  children,
  viewPath,
  patientId
  
})
  return (<React.Fragment
>
<CreateNewProfessionalModal
  viewPath={`${viewPath}/CreateNewProfessionalModal`}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 onCancel={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 onSave={onSave}
 patientId={patientId}
/>
{children}
</React.Fragment>)
}